import { useEffect, useState, type ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";
import { FormDrawer } from "@/app/FormDrawer";
import type { RoutingReferences } from "@/app/routing";
import { EmptyState } from "@/ui";

/** 捕获对象与引用后固定编辑快照，刷新不能卸载表单、丢草稿或502状态（D126）。 */
export function RoutingEditLoader<T extends { id: number }>({ row, queryKey, noun, resource, onClose, children }: {
  row: T | null; queryKey: string; noun: string;
  resource: { get: (id: number) => Promise<T>; references: (id: number) => Promise<RoutingReferences> };
  onClose: () => void; children: (row: T | null, refs: RoutingReferences) => ReactNode;
}) {
  const [loaded, setLoaded] = useState<{ row: T; references: RoutingReferences } | null>(null);
  // 对象版本不能识别其它会话新增的引用；每次打开都重新读取，不沿用全局10秒缓存。
  const detail = useQuery({ queryKey: [queryKey, "detail", row?.id], queryFn: () => resource.get(row!.id), enabled: !!row && !loaded, staleTime: 0, refetchOnMount: "always" });
  const references = useQuery({ queryKey: [queryKey, "references", row?.id], queryFn: () => resource.references(row!.id), enabled: !!row && !loaded, staleTime: 0, refetchOnMount: "always" });
  useEffect(() => {
    if (!loaded && detail.data && references.data && !detail.isFetching && !references.isFetching && !detail.error && !references.error)
      setLoaded({ row: detail.data, references: references.data });
  }, [loaded, detail.data, references.data, detail.isFetching, references.isFetching, detail.error, references.error]);
  if (row && !loaded) return <FormDrawer open title={`读取${noun}`} saving error={detail.error?.message ?? references.error?.message ?? null} onSubmit={() => undefined} onClose={onClose}><EmptyState title={detail.error || references.error ? `${noun}或引用读取失败` : "加载中"}>请关闭后重新读取，禁止在引用范围不明时修改。</EmptyState></FormDrawer>;
  return children(loaded?.row ?? null, loaded?.references ?? { account_ids: [], template_ids: [] });
}
